import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const LanguageContext = createContext();

const getInitialLanguage = () => {
  if (typeof window === 'undefined') {
    return 'en';
  }
  const stored = window.localStorage.getItem('lang');
  if (stored === 'en' || stored === 'zh') {
    return stored;
  }
  const nav = (window.navigator.language || '').toLowerCase();
  return nav.startsWith('zh') ? 'zh' : 'en';
};

export const LanguageProvider = ({ children }) => {
  // SSR 与构建出的静态 HTML 一致，避免 hydration mismatch
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const initial = getInitialLanguage();
    if (initial !== 'en') {
      setLanguage(initial);
    }
  }, []);

  const setAndPersist = lang => {
    setLanguage(lang);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('lang', lang);
    }
  };

  const toggleLanguage = () => {
    setAndPersist(language === 'en' ? 'zh' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

LanguageProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useLanguage = () => useContext(LanguageContext);
